import api from "api/api";
import { Toast } from "components/toast";
import { Pipeline } from "..";

export async function getPipelineData(mailingId: number): Promise<Pipeline[]> {
  try {
    const { data } = await api.get<Pipeline[]>(
      `/pipeline/status/mailing/${mailingId}`
    );
    return data;
  } catch (e: any) {
    Toast({
      title: "Erro ao obter dados mailing",
      status: "error",
    });
    throw e;
  }
}

export async function advancePipelineApi(
  mailingId: number,
  pipelineStage: string
): Promise<void> {
  try {
    await api.post(`/pipeline/${mailingId}/advance`, { pipelineStage });
  } catch (e: any) {
    const errorMessage =
      typeof e?.response?.data === "string" && e?.response?.data !== ""
        ? e?.response?.data
        : "Erro ao avançar pipeline";

    Toast({
      title: errorMessage,
      status: "error",
    });
    throw e;
  }
}

export async function downloadMailingCsv(mailingId: number): Promise<Blob> {
  try {
    const { data } = await api.get(`pipeline/mailing/${mailingId}/download`);
    return new Blob([data]);
  } catch (e: any) {
    Toast({
      title: "Erro ao baixar CSV",
      status: "error",
    });
    throw e;
  }
}
